<template>
  <div
    :class="{
      'is-frame-mode': isFrameMode,
    }"
  >
    <div id="legacy-app">
      <div ui-view></div>
    </div>
    <router-view />
  </div>
</template>

<script>
import Favicon from '@/assets/favicon.ico';
import { getters } from '@/modules/core/app/helpers/store';
import NotificationService from '@/modules/core/ui/services/NotificationService';
import LegacyAssetResource from '@/modules/legacy/ui/resources/LegacyAssetResource';

export default {
  computed: {
    isFrameMode() {
      return getters.session.getUserSettings().isFrameMode;
    },
  },
  beforeRouteEnter(to, from, next) {
    (async () => {
      const link = document.getElementById('favicon');
      // PDF exports do not include link tag.
      if (link) {
        const userSettings = getters.session.getUserSettings() || {};
        const shouldHideBranding = userSettings.shouldHideTapClicksBranding;
        let iconUrl = Favicon;
        if (shouldHideBranding) {
          // eslint-disable-next-line no-undef
          iconUrl = `${ASSET_PATH}generic.ico`;
        } else if (userSettings.whitelabelClusterId) {
          const whitelabelFaviconUrl = await LegacyAssetResource.getAssetUrl(
            `favicon_image_cluster-${userSettings.whitelabelClusterId}`
          );
          iconUrl = whitelabelFaviconUrl?.data ? whitelabelFaviconUrl.data : Favicon;
        }
        link.href = iconUrl;
        window.localStorage.setItem('tcfi', iconUrl);
        // If there is a status message, display it
        const statusMessage = userSettings.statusMessage
          ? JSON.parse(userSettings.statusMessage)
          : '';
        if (statusMessage?.message) {
          NotificationService.show(statusMessage.message, { duration: 200000 });
        }
      }
    })();
    next();
  },
  mounted() {
    const $appLoader = document.getElementById('app-loader');
    if ($appLoader) {
      $appLoader.remove();
    }
  },
};
</script>
